<bp-otp-on-login-form
	class="h-100"
	[pending]="introFacade.pending$ | async"
	[error]="introFacade.error$ | async"
	(submitted)="identityFacade.loginOtpVerification($event)"
	(login)="introFacade.gotoLoginPage()"
	(resetAuthApp)="introFacade.gotoSendResetAuthenticatorAppLinkPage()"
>
</bp-otp-on-login-form>
